import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Progress,
  Row,
} from "reactstrap";
import { Link } from "react-router-dom";

const MapValues = props => {
  const [errors, setErrors] = React.useState([]);

  React.useEffect(() => {
    setErrors(prev => {
      if (prev !== props.validationErrors) {
        return props.validationErrors;
      }
    });

    if (props.activeTab < 4 && props.validationSuccess) {
      props.setMapperValidationSuccess(false);
    }
  }, [props.validationErrors, props.activeTab]);

  const generateErrors = item => {
    let err = [];
    for (let [key, value] of Object.entries(item[0])) {
      err.push(
        <React.Fragment key={key}>
          <strong>{key}</strong>: {item[0][key][0]} <br />
        </React.Fragment>
      );
    }
    return err;
  };

  return (
    <React.Fragment>
      {!props.success ? (
        <>
          <CardTitle className="h4">Upload widget: Map values</CardTitle>
          <p className="card-title-desc mb-0">
            If you want to upload file click the <strong>Begin Import</strong>{" "}
            button. To check for validity, click the <strong>Validate</strong>{" "}
            button. If problems occur during the validation of fields, they will
            be described below.
          </p>

          {props.validationProcess && (
            <Row className="justify-content-md-center mt-3 fade-in-custom-animate">
              <Col lg={12}>
                <h6 align="center">
                  {props.addMappProcess
                    ? "Table are being imported, please wait..."
                    : "Validation process is active, please wait..."}
                </h6>
                <Progress
                  value={100}
                  color="primary"
                  style={{ width: "100%" }}
                  animated
                ></Progress>
              </Col>
            </Row>
          )}
          {props.validationErrors.length !== 0 && (
            <Row className="justify-content-md-center mt-3">
              <Col lg={12} className="fade-in-custom-animate">
                <Card color="danger" className="text-white-50 mb-0">
                  <CardBody>
                    <CardTitle className="h5 mt-0 mb-4 text-white">
                      <i className="mdi mdi-block-helper me-3"></i>Found errors
                      in {props.validationErrors.length} lines
                    </CardTitle>
                    <CardText className="text-white">
                      {props.validationErrors &&
                        generateErrors(props.validationErrors)}
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
          {props.validationSuccess && (
            <Row className="justify-content-md-center mt-3">
              <Col lg={12} className="fade-in-custom-animate">
                <Card color="success" className="text-white-50 mb-0">
                  <CardBody>
                    <CardTitle className="h5 mt-0 mb-4 text-white">
                      <i className="mdi mdi-check-all me-3"></i> Success
                    </CardTitle>
                    <CardText className="text-white">
                      Success! The validator didnt find anything wrong. You can
                      now safely begin your import!
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </>
      ) : (
        <>
          <Row className="justify-content-md-center fade-in-custom-animate">
            <Col lg={12} className="fade-in-custom-animate">
              <Card color="success" className="text-white-50 mb-0">
                <CardBody>
                  <CardTitle className="h5 mt-0 mb-4 text-white">
                    <i className="mdi mdi-check-all me-3"></i> Success
                  </CardTitle>
                  <CardText className="text-white">
                    Upload table has been successfully
                  </CardText>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <p className="card-title-desc mt-3 mb-0 text-center">
            You can import another table,{" "}
            <Link
              onClick={() => props.successfullyUpload()}
              to={{
                pathname: `/upload-widget`,
              }}
            >
              go to the first step
            </Link>{" "}
            or{" "}
            <Link
              to={{
                pathname: `/dashboard`,
              }}
            >
              return to the main page
            </Link>
            .
          </p>
        </>
      )}
    </React.Fragment>
  );
};

MapValues.propTypes = {
  mapData: PropTypes.any,
  data: PropTypes.any,
  setMapperValidationSuccess: PropTypes.func,
  activeTab: PropTypes.node,
  validationErrors: PropTypes.any,
  validationProcess: PropTypes.bool,
  validationSuccess: PropTypes.bool,
  successfullyUpload: PropTypes.func,
  success: PropTypes.bool,
  addMappProcess: PropTypes.bool,
};

export default connect()(MapValues);
